
import { Component, Mixins } from 'vue-property-decorator';
import { ProfileFilter } from 'client-website-ts-library/filters';
import { Profile, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import { API } from 'client-website-ts-library/services';
import { View } from 'client-website-ts-library/plugins';

import Panels from '@/components/Panels.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Loader from '../components/UI/Loader.vue';

@Component({
  components: {
    ProfileCards,
    Loader,
    Panels,
  },
})
export default class OurTeam extends Mixins(View) {
  private profiles: Profile[] = [];

  mounted() {
    const filter = new ProfileFilter();

    API.Profiles.Search(filter).then((profiles) => {
      this.profiles = profiles;
    });
  }

  get getProfiles(): Profile[] {
    let tempProfiles: Profile[] = [];
    tempProfiles = tempProfiles.concat(this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Principal));
    tempProfiles = tempProfiles.concat(this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Agent));
    tempProfiles = tempProfiles.concat(this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PropertyManager));
    tempProfiles = tempProfiles.concat(this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PersonalAssistant));

    return tempProfiles;
  }
}
